<template>
  <div v-if="user">
    <table class="table">
      <tbody>
        <tr>
          <th>ID</th>
          <td>{{ user.id }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <th>Role</th>
          <td>{{ user.role }}</td>
        </tr>
      </tbody>
    </table>

    <router-link :to="{ name: 'UsersIndex' }" class="btn btn-secondary">Back</router-link>
    <div v-if="history" class="card" v-for="entry in history" :key="history.id" :id="history.id">
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ entry.id }}</td>
          </tr>
          <tr>
            <th>Event</th>
            <td>
              <span v-if="entry.event === 'update'" class="font-weight-bold text-info">Update</span>
              <span v-if="entry.event === 'create'" class="font-weight-bold text-success">Create</span>
            </td>
          </tr>
          <tr>
            <th>Whodunnit</th>
            <td>{{ entry.whodunnit }}</td>
          </tr>
          <tr>
            <th>Created At</th>
            <td>{{ entry.created_at }}</td>
          </tr>
          <tr>
            <th>Changes</th>
            <td>
              <table class="table">
                <thead>
                  <tr>
                    <th>Column</th>
                    <th>From</th>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(change, name) in entry.object_changes" :key="JSON.stringify(change)" :id="JSON.stringify(change)">
                    <th>{{ name }}</th>

                    <!-- FROM -->
                    <td v-if="change[0] === null">
                      <span class="text-muted">NULL</span>
                    </td>
                    <td v-else>
                      <span class="text-danger">{{ change[0] }}</span>
                    </td>

                    <!-- TO -->
                    <td v-if="change[1] === null">
                      <span class="text-muted">NULL</span>
                    </td>
                    <td v-else>
                      <span class="text-success">{{ change[1] }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-else>
    There's actually nothing here.
  </div>
</template>

<script>

import { UserService } from '@/common/services/user.service';

export default {
  name: 'UserShow',
  components: {

  },
  props: [
    'id',
  ],
  data() {
    return {
      user: null,
      history: null,
    };
  },
  created() {
    this.getUser(this.id);
    this.getUserHistory(this.id);
  },
  methods: {
    getUser(params) {
      UserService.get(params).then((response) => {
        this.user = response.data;
      });
    },
    getUserHistory(params) {
      UserService.history(params).then((response) => {
        this.history = response.data;
      });
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
